/* eslint-disable */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { menuLateralWidth } from '@utils/const';
import m from '@utils/strings';
import '@styles/consulta-pronto-socorro.css';

const styles = {
    divContainer: {
        position: "absolute",
        right: 0,
        height: '100%',
        width: menuLateralWidth,
        backgroundColor: "#f5f5f6",
        marginTop: -100,
        padding: 25,
        zIndex: 0
    },
    divContainerExterno: {

    },
    nomeUsuario: {
        height: 24,
        color: "#333333",
        fontFamily: "Work Sans",
        fontSize: 17,
        fontWeight: 400,
    },
    circle: {
        width: 6,
        height: 6,
        backgroundColor: "#7bc72a",
        borderRadius: "50%",
        marginBottom: 0,

    },
    statusUsuario: {
        height: "14",
        color: "#7bc72a",
        fontFamily: "Work Sans",
        fontSize: 12,
        fontWeight: 400,
        marginLeft: 5,
    },
    dataVerificacao: {
        color: "#9b9b9b",
        fontFamily: "Work Sans",
        fontSize: 12,
        fontWeight: 400,
    },
    numeroCarteira: {
        height: 16,
        color: "#333333",
        fontFamily: "Work Sans",
        fontSize: 14,
        fontWeight: 400,
    },
    numeroCartao: {
        height: 20,
        color: "#333333",
        fontFamily: "Source Code Pro",
        fontSize: 16,
        fontWeight: 700,
        letterSpacing: 2,
    },
    dadosSolicitante: {
        height: 16,
        color: "#333333",
        fontFamily: "Work Sans",
        fontSize: 16,
        fontWeight: 400,
    },
    dadosSolicitanteDescricao: {
        height: 16,
        color: "#9b9b9b",
        fontFamily: "Work Sans",
        fontSize: 14,
        fontWeight: 400,
    },
    procedimentoOutroSolicitanteRectangle: {
        width: 312,
        height: 148,
        paddingLeft: 30,
        paddingRight: 30,
        borderRadius: 6,
        border: '1px solid #fbb12f',
        backgroundColor: 'white',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.8,
        shadowRadius: 2,
        elevation: 1,
        textAlign: 'center',
        display: 'table-cell',
        verticalAlign: 'middle',
        color: "#333333",
        fontFamily: "Work Sans",
        fontSize: 16,
        fontWeight: 400,
    }
}

class MenuLateralUsuarioConsultaPs extends Component {

    formataHorarioAtual() {
        var tempDate = new Date();
        let day = (tempDate.getDate()).toString();
        let month = (tempDate.getMonth() + 1).toString();
        let hours = (tempDate.getHours()).toString();
        let minutes = (tempDate.getMinutes()).toString();

        day = day.length == 1 ? '0' + day : day;
        month = month.length == 1 ? '0' + month : month;
        hours = hours.length == 1 ? '0' + hours : hours;
        minutes = minutes.length == 1 ? '0' + minutes : minutes;

        var date = day + '/' +
            month + '/' +
            tempDate.getFullYear() + ' ' +
            hours + ':' +
            minutes;
        const currDate = m.MENU_LATERAL.VERIFICADO_EM + date;
        return currDate;
    }

    formataHorarioAtendimento(data) {
        var tempDate = new Date();
        let day = (tempDate.getDate()).toString();
        let month = (tempDate.getMonth() + 1).toString();

        day = day.length == 1 ? '0' + day : day;
        month = month.length == 1 ? '0' + month : month;

        var date = day + '/' +
            month + '/' +
            tempDate.getFullYear()
        const currDate = m.MENU_LATERAL.BENEFICIARIO_ATIVO_EM + data;
        return currDate;
    }

    render() {
        const { classes, beneficiario } = this.props;
        
        if (beneficiario && beneficiario.data && beneficiario.data.SolicitacaoProcedimento.Senha) {
            const { data: { SolicitacaoProcedimento } } = beneficiario
            const horario_verificacao = this.formataHorarioAtual();
            const horario_atendimento = this.formataHorarioAtendimento(this.props.dataAutorizacao);
            return (
                <div className={classes.divContainer}>
                    <div className={classes.divContainerExterno}>
                        <div className={"divContainerInterno"} style={{ display: "inherit" }}>
                            <div className={"divExterior"}>
                                <div className={"divInterior"}>
                                    <label className={classes.nomeUsuario}>{SolicitacaoProcedimento.Beneficiario.Nome}</label>
                                </div>
                            </div>
                        </div>
                        <div className={"divContainerInterno"} style={{ display: "inherit", marginTop: -5 }}>
                            <div className={"divExterior"}>
                                <div className={"divInterior"}>
                                    <label className={classes.circle}></label>
                                    <label className={classes.statusUsuario}>{horario_atendimento}</label>
                                </div>
                            </div>
                        </div>
                        <div className={"divContainerInterno"} style={{ display: "inherit", marginTop: -5 }}>
                            <div className={"divExterior"}>
                                <div className={"divInterior"}>
                                    <label className={classes.dataVerificacao}>{SolicitacaoProcedimento && SolicitacaoProcedimento.Beneficiario && SolicitacaoProcedimento.Beneficiario.IdentificadorRecemNato ? m.MENU_LATERAL.LABEL_RECEM_NASCIDO : ""}</label>
                                </div>
                            </div>
                        </div>
                        <div className={"divContainerInterno"} style={{ display: "inherit", marginTop: -5 }}>
                            <div className={"divExterior"}>
                                <div className={"divInterior"}>
                                    <label className={classes.dataVerificacao}>{horario_verificacao}</label>
                                </div>
                            </div>
                        </div>
                        <div className={"divContainerInterno"} style={{ display: "inherit", marginTop: 15 }}>
                            <div className={"divExterior"}>
                                <div className={"divInterior"}>
                                    <label className={classes.numeroCarteira}>{m.MENU_LATERAL.LABEL_NUMERO_CARTEIRA_SAUDE}</label>
                                </div>
                            </div>
                        </div>
                        <div className={"divContainerInterno"} style={{ display: "inherit" }}>
                            <div className={"divExterior"}>
                                <div className={"divInterior"}>
                                    <label className={classes.numeroCartao}>{SolicitacaoProcedimento.Beneficiario.NumeroCarteira}</label>
                                </div>
                            </div>
                        </div>
                        {/* <div className={"divContainerInterno"} style={{ display: "inherit", marginTop: 15 }}>
                            <div className={"divExterior"}>
                                <div className={"divInterior"}>
                                    <label className={classes.numeroCarteira}>{m.MENU_LATERAL.LABEL_CARTAO_NACIONAL_SAUDE}</label>
                                </div>
                            </div>
                        </div>
                        <div className={"divContainerInterno"} style={{ display: "inherit" }}>
                            <div className={"divExterior"}>
                                <div className={"divInterior"}>
                                    <label className={classes.numeroCartao}>
                                        {SolicitacaoProcedimento.Beneficiario.CartaoNacionalSaude ? SolicitacaoProcedimento.Beneficiario.CartaoNacionalSaude : m.MENU_LATERAL.MENSAGEM_CARTAO_NAO_INFORMADO}
                                    </label>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            )
        } else {
            return (
                <div className={classes.divContainer}>
                    <div className={classes.divContainerExterno}>
                    </div>
                </div>
            );
        }
    }
}

export default withStyles(styles)(MenuLateralUsuarioConsultaPs)
